import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../actions/taskActions';
import * as api from '../api/tasks';
import { loadIsler, saveIsler } from 'src/utils/storage/WorkOrder'

function* getTasks() {
  try {
    let result = '';
    if (window.navigator.onLine) {
      result = yield call(api.getTasks);
      saveIsler(result.data);
      yield put(actions.getTasksSuccess(result.data));
    } else {
      result = loadIsler();
      yield put(actions.getTasksSuccess(result));
    }
  } catch (error) {
    var resultError = loadIsler();
    yield put(actions.getTasksSuccess(resultError));
  }
}

function* watchGetTaskRequest() {
  yield takeEvery(actions.Types.GET_TASK_REQUEST, getTasks);
}

const taskSagas = [fork(watchGetTaskRequest)];

export default taskSagas;
